<template>
    <div class="ideal_container transition" id="ideal_container">
        <div class="ideal_list">
            <div class="ideal_back_top" @click="back_top">
                <div style="margin: 0 auto;border-bottom-left-radius: 4px;font-weight: bold">顶部</div>
            </div>
        </div>
    </div>
    <div>
        <el-backtop style="display: none;" id="el_back_top">顶部</el-backtop>
    </div>
</template>

<script>

export default {
    name: 'Header',
    props: {
    },
    data() {
        return {
        }
    },
    watch: {
    },
    created() {
    },
    methods: {
        back_top() {
            $("#el_back_top").click()
        },
    }
}
</script>
<style scoped>
.ideal_container {
    z-index: 999999;
    position: fixed;
    bottom: 100px;
    right: 10px;
    color: white;
    cursor: pointer;
    display: flex;
}

.ideal_list {
    width: 45px;
}
.ideal_back_top {
    margin: 0 auto;
    height: 45px;
    line-height: 45px;
    border: 1px #E93A29 solid;
    border-radius: 5px;
    color: #E93A29;
    display: flex;
    justify-content: center;
}

.transition {
    transition: all 0.5s ease-in-out 0s;
}
</style>
